module.exports = __webpack_public_path__ + "static/media/29_MichaelWalta_webfinal.f28f1cae.jpg";